import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Title, Note } from 'components/misc'
import styles from './assessor-empty-dashboard.styl'

import iconPhysical from 'assets/img/activities/icon-physical-big.svg'
import iconSkills from 'assets/img/activities/icon-skills-big.svg'
import iconService from 'assets/img/activities/icon-service-big.svg'
import iconAj from 'assets/img/activities/icon-aj-big.svg'
import iconResidental from 'assets/img/activities/icon-residental-big.svg'

const icons = [
  iconPhysical,
  iconSkills,
  iconService,
  iconAj,
  iconResidental
]

class AssessorEmptyDashboard extends PureComponent {
  static propTypes = {
    isLoading: PropTypes.bool
  }

  render() {
    const { isLoading } = this.props

    if (isLoading) {
      return <div />
    }

    return (
      <div className={styles.wrapper}>
        <div className={styles.images}>
          {icons.map(path => <img key={path} src={path} />)}
        </div>
        <Title h1 intlKey="moduleTitle.assessor_welcome_to_orb">
          Welcome to Online Record Book
        </Title>
          <div>
             <Note
                  key="approved_1"
                  fontSize="1.6rem"
                  intlKey="empty_dashboard.assessor_note_01"
                >
                  This tool will help you work with assessed participants.
                </Note>
                <Note
                  key="approved_2"
                  fontSize="1.6rem"
                  intlKey="empty_dashboard.assessor_note_02"
                >
                  To start, click on one of the left.
                </Note>
          </div>
      </div>
    )
  }
}

export default AssessorEmptyDashboard
